export default __webpack_public_path__ + "static/media/Armbands of the Kozak Slayer.3874505a.jpg";